module.exports = __webpack_public_path__ + "img/map_base.d28206e6.png";